import { action, observable, makeObservable } from 'mobx';
import { InputState } from '../components/input/input.state';

export class TagEditState {
	@observable tagId?: string = undefined;
	@observable renamingTagId?: string = undefined;

	input: InputState;

	constructor(text: string) {
		makeObservable(this);

		this.input = new InputState(text);
	}

	@action setTagId(tagId: string) {
		this.tagId = tagId;
	}

	@action setRenaming(tagId: string) {
		this.renamingTagId = tagId;
	}

	@action cancelRenaming() {
		this.setRenaming(undefined);
	}

	@action editTag(tagId: string, value?: string) {
		this.setTagId(tagId);
		this.input.setValue(value);
	}

	isEditingTag(tagId?: string): boolean {
		if (tagId == null) {
			return this.input.value != null;
		}

		return this.input.value != null && this.tagId === tagId;
	}

	isRenamingTag(tagId?: string): boolean {
		if (tagId == null) {
			return this.renamingTagId != null;
		}

		return this.renamingTagId === tagId;
	}
}
